"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const silo_types_1 = require("./silo.types");
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const initialState = {
    onReset: false,
    isLoading: true,
    isLoadingDetail: true,
    isLoadingHistory: true,
    onCallWebSocket: true,
    isToast: false,
    messageToast: '',
    isError: false,
    isSuccess: false,
    errorCode: 0,
    isPushLED: false,
    errorMessage: '',
    dataConfigSilo: [],
    mutationMode: false,
    dataHistory: [],
    listHauler: [],
    dataDriver: [],
    status: 'Offline',
    rfid_tag_latetst: '',
    isGetDataHauler: false,
    hex_tag: '',
    dataItem: {
        id: '',
        contractor_id: '',
        contractor_name: '',
        brand_id: '',
        brand_code: '',
        brand_name: '',
        brand_color: '',
        hauler_id: '',
        hauler_no: '',
        hauler_rfid_tag: '',
        vessel1_id: '',
        vessel1_no: 0,
        vessel2_id: '',
        vessel2_no: 0,
        driver_id: '',
        driver_name: '',
        checkpoint_id: '',
        checkpoint_name: '',
        ticket_no: '',
        main_entrance_in: new Date(),
        gate_in: new Date(),
        gate_out: new Date(),
        capacity_volume1: 0,
        capacity_volume2: 0,
        total_volume: 0,
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        is_active: false,
        driver: {}
    },
    dataHauler: {
        id: '',
        contractor_id: '',
        contractor_name: '',
        created_date: new Date(),
        created_by: '',
        modified_date: new Date(),
        modified_by: '',
        ticket_no: '',
        image_penalty_evidence: '',
        gate_in: new Date(),
        gate_out: new Date(),
        main_entrance_in: new Date(),
        is_active: false,
        hauler_id: '',
        hauler_no: '',
        hauler_rfid_tag: '',
        vessel1_id: '',
        vessel1_no: 0,
        vessel2_id: '',
        vessel2_no: 0,
        driver_id: '',
        driver_name: '',
        checkpoint_id: '',
        checkpoint_name: '',
        capacity_volume1: 0,
        capacity_volume2: 0,
        total_volume: 0,
        brand_id: '',
        brand_name: '',
        brand_color: '',
        brand_code: '',
    },
    dataItemHistory: {
        id: '',
        contractor_id: '',
        contractor_name: '',
        created_date: new Date(),
        created_by: '',
        modified_date: new Date(),
        modified_by: '',
        ticket_no: '',
        image_penalty_evidence: '',
        gate_in: new Date(),
        gate_out: new Date(),
        main_entrance_in: new Date(),
        is_active: false,
        hauler_id: '',
        hauler_no: '',
        hauler_rfid_tag: '',
        vessel1_id: '',
        vessel1_no: 0,
        vessel2_id: '',
        vessel2_no: 0,
        driver_id: '',
        driver_name: '',
        checkpoint_id: '',
        checkpoint_name: '',
        capacity_volume1: 0,
        capacity_volume2: 0,
        total_volume: 0,
        brand_id: '',
        brand_name: '',
        brand_color: '',
        brand_code: '',
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'virtual',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
    dataStatesHistory: {
        filterable: false,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }],
    },
};
const siloReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [silo_types_1.siloTypes.RESET]: (state, action) => {
        const { onReset } = action.payload;
        return Object.assign(Object.assign({}, state), { onReset: onReset });
    },
    [silo_types_1.siloTypes.SET_SUBMIT_LOADING]: (state, action) => {
        const { isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit });
    },
    [silo_types_1.siloTypes.SET_DATA_GRID]: (state, action) => {
        const { count } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [silo_types_1.siloTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStatesHistory, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesHistory,
            dataGrid, isLoading: false });
    },
    [silo_types_1.siloTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: action.payload.dataStatesHistory });
    },
    [silo_types_1.siloTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, rfid_tag_latests, dataItemHistory, dataHauler, isLoadingHistory, isToast, messageToast } = action.payload;
        return Object.assign(Object.assign({}, state), { rfid_tag_latetst: rfid_tag_latests ? rfid_tag_latests : '', dataItemHistory: dataItemHistory ? dataItemHistory : initialState.dataItemHistory, mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoadingHistory: isLoadingHistory ? isLoadingHistory : true, dataHauler: dataHauler ? dataHauler : initialState.dataHauler, isToast: isToast ? isToast : initialState.isToast, messageToast: messageToast ? messageToast : initialState.messageToast });
    },
    [silo_types_1.siloTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { isError } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess: !isError, isLoadingSubmit: false, dataHauler: Object.assign({}, initialState.dataHauler), isGetDataHauler: false, mutationMode: false, onCallWebSocket: true });
    },
    [silo_types_1.siloTypes.ON_DELETE]: (state, action) => {
        const { isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem });
    },
    [silo_types_1.siloTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { filter: action.payload }) });
    },
    [silo_types_1.siloTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { sort: action.payload }) });
    },
    [silo_types_1.siloTypes.GET_HAULER_LIST]: (state, action) => {
        const { listHauler } = action.payload;
        return Object.assign(Object.assign({}, state), { listHauler });
    },
    [silo_types_1.siloTypes.GET_HAULER_BY_NO]: (state, action) => {
        const { dataItem } = action.payload;
        return Object.assign(Object.assign({}, state), { dataItem });
    },
    [silo_types_1.siloTypes.GET_DROPDOWN]: (state, action) => {
        const { dataDriver } = action.payload;
        return Object.assign(Object.assign({}, state), { dataDriver });
    },
    [silo_types_1.siloTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isLoadingSubmit: false, onCallWebSocket: false });
    },
    [silo_types_1.siloTypes.SET_DATA_SILO_CONFIG]: (state, action) => {
        const { dataConfigSilo, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataConfigSilo, isLoading: false, isPushLED: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [silo_types_1.siloTypes.SET_DATA_HAULER]: (state, action) => {
        const { dataHauler } = action.payload;
        return Object.assign(Object.assign({}, state), { hex_tag: dataHauler.hauler_rfid_tag, dataHauler: Object.assign(Object.assign({}, state.dataHauler), dataHauler), dataItem: Object.assign(Object.assign({}, state.dataHauler), dataHauler), isGetDataHauler: true, onCallWebSocket: false, status: 'Online' });
    },
    [silo_types_1.siloTypes.SET_DATA_HOPPER]: (state, action) => {
        const { dataSiloTabs } = action.payload;
        return Object.assign(Object.assign({}, state), { dataHauler: Object.assign(Object.assign({}, state.dataHauler), { checkpoint_id: dataSiloTabs ? dataSiloTabs === null || dataSiloTabs === void 0 ? void 0 : dataSiloTabs.checkpoint_id : '', checkpoint_name: dataSiloTabs ? dataSiloTabs === null || dataSiloTabs === void 0 ? void 0 : dataSiloTabs.checkpoint_name : '' }) });
    },
    [silo_types_1.siloTypes.SET_DATA_HISTORY]: (state, action) => {
        const { dataHistory, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataHistory, isLoading: false, isLoadingHistory: true, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: count }) });
    },
    [silo_types_1.siloTypes.SET_STATUS]: (state, action) => {
        const { status } = action.payload;
        return Object.assign(Object.assign({}, state), { status });
    },
    [silo_types_1.siloTypes.SET_HEX]: (state, action) => {
        const { hex_tag } = action.payload;
        return Object.assign(Object.assign({}, state), { hex_tag });
    },
    [silo_types_1.siloTypes.ON_PUSH_LED]: (state) => {
        return Object.assign(Object.assign({}, state), { isPushLED: false });
    },
    [silo_types_1.siloTypes.HAULER_NOT_FOUND]: (state, action) => {
        const { isToast, onCallWebSocket, messageToast } = action.payload;
        return Object.assign(Object.assign({}, state), { onCallWebSocket,
            messageToast,
            isToast });
    }
});
exports.default = siloReducer;
